import { Grid, OutlinedInput } from '@material-ui/core';
import { CourierPreferencesJson } from 'fetch/fetchCourierPreferences';
import React, { ChangeEvent, useEffect, useState } from 'react';
import './DeliveriesConfigInput.scss';

interface DeliveriesConfigInputProps {
  name: keyof CourierPreferencesJson;
  label: string;
  defaultValue: string | number;
  editable?: boolean;
  onChange?: (newValue: number) => void;
  addInvalidInput: (inputName: string) => void;
  removeInvalidInput: (inputName: string) => void;
}

export const DeliveriesConfigInput = ({
  ...props
}: DeliveriesConfigInputProps) => {
  const [value, setValue] = useState(props.defaultValue || 0);

  const onValueChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = Number(e.target.value) || 0;
    setValue(newValue);

    if (newValue < 0) {
      props.addInvalidInput(props.name);
    } else {
      props.removeInvalidInput(props.name);
    }

    props.onChange(newValue);
  };

  const invalidInputValue = value < 0;

  /* Update when the DefaultValue changed after API fetched */
  useEffect(() => {
    setValue(props.defaultValue);
  }, [props.defaultValue]);

  return (
    <div className="config-container">
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item>
          <p className="label">{props.label}</p>
          {props.editable ? (
            <OutlinedInput
              className="config-input"
              type="number"
              id={props.name}
              value={value}
              onChange={onValueChange}
              error={invalidInputValue}
            />
          ) : (
            <p className="config-value">{value || '-'}</p>
          )}
        </Grid>
      </Grid>
    </div>
  );
};
